export default __webpack_public_path__ + "static/media/cancel.dcf94367.png";